'use strict';

var define = require('define-properties');
var getPolyfill = require('./polyfill');

module.exports = function shimArrayPrototypeFind() {
	var polyfill = getPolyfill();

	define(Array.prototype, { find: polyfill }, {
		find: function () {
			return Array.prototype.find !== polyfill;
		}
	});

	return polyfill;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/array.prototype.find/shim.js
 ** module id = 108
 ** module chunks = 0
 **/